<template>
	<div class="mainBottom">
				<div class="footer">
					<div class="footer_m1">
						<div style="color: #fff;font-size: 18px;line-height: 76px;">网站信息</div>
						<div style="color: #b6b6b6;font-size: 17px;float: left;">
							<div style="float: left;display: inline-block;width: 95px;">主办单位
							</div>
							<div style="float: left;width: 120px; display: inline-block; margin-left: 15px;" v-for="item in info" v-if="item.bottomType==bottomInfo.zbdw">{{item.bottomName}}</div></div>
	<!--					<div style="color: #b6b6b6;font-size: 17px;">协办单位<span  style="margin-left: 34px;">科技</span></div>-->
	<!--					<div style="color: #b6b6b6;font-size: 16px;">支持单位<span  style="margin-left: 34px;">沃嘉科技</span></div>-->
					</div>bottomType
					<div class="footer_m2">
						<div style="color: #fff;font-size: 18px;line-height: 76px;">云展会服务</div>
						<div style="color: #b6b6b6;font-size: 17px;float: left;">
							<div style="float: left;display: inline-block;width: 95px;">
								联系人
							</div>

							<div v-for="item in info" v-if="item.bottomType==bottomInfo.lxr" style="float: left;width: 150px; display: inline-block;margin-left: 15px;">{{item.bottomName}}</div>
						</div>
						<div style="color: #b6b6b6;font-size: 17px;float: left;">
							<div style="float: left;display: inline-block;width: 95px;">
								咨询电话
							</div>
							<div v-for="item in info" v-if="item.bottomType==bottomInfo.zxdh"  style="float: left;width: 150px;display: inline-block;margin-left: 15px;">{{item.bottomName}}</div>
						</div>
						<div style="color: #b6b6b6;font-size: 17px;float: left;">
							<div style="float: left;display: inline-block;width:95px;">
								咨询邮箱
							</div>
							<div v-for="item in info" v-if="item.bottomType==bottomInfo.zxyx"  style="float: left;width: 150px;display: inline-block;margin-left: 15px;">{{item.bottomName}}</div>
						</div>
						<div style="color: #b6b6b6;font-size: 17px;float: left;">
							<div style="float: left;display: inline-block;width: 95px;">
								咨询微信
							</div>
							<div v-for="item in info" v-if="item.bottomType==bottomInfo.zxwx"  style="float: left;width: 150px;display: inline-block;margin-left: 15px;">{{item.bottomName}}</div>
						</div>
					</div>
					<div class="footer_m3">
						<div style="color: #fff;font-size: 18px;line-height: 76px;">云展会平台</div>
						<div style="color: #b6b6b6;font-size: 17px;float: left;">
							<div style="float: left;display: inline-block;width: 95px;">
								电话
							</div>
							<div v-for="item in info" v-if="item.bottomType==bottomInfo.dh" style="display: inline-block;float: left;width: 150px;margin-left: 15px;">{{item.bottomName}}</div>
						</div>
						<div style="color: #b6b6b6;font-size: 17px;float: left;">
							<div style="float: left;display: inline-block;width: 95px;">
								技术支持
							</div>
							<div v-for="item in info" v-if="item.bottomType==bottomInfo.jszc"  style="display: inline-block;float: left;width: 150px;margin-left: 15px;">{{item.bottomName}}</div>
						</div>

					</div>
					<div class="yzhgzh" style="width: 94px;display: inline-block;float: left;margin-top: 78px;margin-left: 31px;">
						<img v-for="item in info" v-if="item.bottomType==bottomInfo.ewm" :src="baseUrl()+item.bottomImg" alt="" style="width: 100%;">
						<div style="color: #fff;font-size: 15px;margin-top: 15px;">云展会公众号</div>
					</div>
				</div>
			</div>
</template>

<script>
	import axios, { Axios } from 'axios';
  import {baseUrl} from "@/components/index";
	export default {
		data(){
			return{
				info:'',
				infoType:'',
				bottomInfo:{
					zbdw:'',
					dh:'',
					jszc:'',
					lxr:'',
					zxdh:'',
					zxyx:'',
					zxwx:'',
					ewm:''
				}
			}
		},
		methods:{
      baseUrl,
			getBottom(){
				axios.get('/system/dict/data/type/yzh_bottom_type',{
					params:{
						// pageSize:20,
						// pageNum:pnum,
					}
				}).then((res)=>{
				    this.infoType=res.data.data
					for(var i=0;i<this.infoType.length;i++){
						if(this.infoType[i].dictLabel=='主办单位'){
							this.bottomInfo.zbdw=this.infoType[i].dictValue
						}
						if(this.infoType[i].dictLabel=='技术支持'){
							this.bottomInfo.jszc=this.infoType[i].dictValue
						}
						if(this.infoType[i].dictLabel=='电话'){
							this.bottomInfo.dh=this.infoType[i].dictValue
						}
						if(this.infoType[i].dictLabel=='联系人'){
							this.bottomInfo.lxr=this.infoType[i].dictValue
						}
						if(this.infoType[i].dictLabel=='咨询电话'){
							this.bottomInfo.zxdh=this.infoType[i].dictValue
						}
						if(this.infoType[i].dictLabel=='咨询邮箱'){
							this.bottomInfo.zxyx=this.infoType[i].dictValue
						}
						if(this.infoType[i].dictLabel=='咨询微信'){
							this.bottomInfo.zxwx=this.infoType[i].dictValue
						}
						if(this.infoType[i].dictLabel=='二维码'){
							this.bottomInfo.ewm=this.infoType[i].dictValue
						}
					}
					// console.log(this.info)

				})
				axios.get('/web/bottom/list',{
					params:{
						pageSize:20,
						// pageNum:pnum,
					}
				}).then((res)=>{
				    this.info=res.data.rows
					// console.log(this.info)

				})
			}
		},
		mounted() {
			this.getBottom()
		}
	}
</script>

<style>
	.mainBottom{
		width: 100%;
		background-color: #150e52;
		height: 380px;
		min-width: 1700px;
		margin-top: 40px;
	}
	.footer{
		width: 1140px;
		min-width: 1140px;
		height: 380px;
		margin: auto;
	}
	.footer_m1{
	width: 284px;
		/* height: 200px; */
		line-height: 38px;
		padding-top: 51px;
		margin-left: 83px;
		display: inline-block;
		float: left;
	}
	.footer_m2{
		width: 308px;
		/* height: 200px; */
		line-height: 38px;
		padding-top: 51px;
		margin-left: 20px;
		display: inline-block;
		float: left;
	}
	.footer_m3{
		width: 260px;
		/* height: 200px; */
		line-height: 38px;
		padding-top: 51px;
		margin-left: 40px;
		display: inline-block;
		float: left;
	}
</style>
